module.exports = __webpack_public_path__ + "static/media/logo.a249dfc3.jpeg";